/**
 * Adzuki
 * account_messages.js
 */

(function AccountMesages($, Adzuki)
{
	"use strict";

	// var get_messages_interval = (1000 * 60 * 1); // 1 min

	// $(document).ready(function documentReady()
	// {
	// 	// handle click
	// 	handleAccountMessageBadgeClick();

	// 	// handle instant notification close
	// 	handleInstantNotificationClick();

	// 	$('.account-message-close').click(function closeAccountMessages(e) {
	// 		$(".account-messages-container").slideToggle("fast");
	// 		$(".account-messages-link a").css('background-color', 'transparent');
	// 	});

	// 	// update account messages badge
	// 	setInterval(function accountMessages() {
	// 		getAgentAccountMessagesBadge();
	// 	}, get_messages_interval);
	// });

	// function getAgentAccountMessagesBadge() {
	// 	// only run if the account messages are not being displayed
	// 	if ($(".account-messages-container").is(':hidden')) {
	// 		Adzuki.Ajax.get('/AccountMessages/getAgentAccountMessagesBadge/')
	// 		.then(function success(data) {
	// 			// update account message badge link
	// 			$('.account-messages-link').html(data);

	// 			handleAccountMessageBadgeClick();
	// 		});

	// 		// handle instant notifications
	// 		Adzuki.Ajax.get('/AccountMessages/listInstantNotifications/')
	// 		.then(function success(data) {
	// 			$('.account-messages-instant-notification-container').html(data);
	// 			$(".account-messages-instant-notification-container").removeClass('hidden');

	// 			handleInstantNotificationClick();
	// 		});
	// 	}
	// }

	// function handleAccountMessageBadgeClick() {
	// 	// handle account messages icon click
	// 	$(".account-messages-link a").click(function accountMessagesShowHide(e) {
	// 		e.preventDefault();

	// 		// if task manager is open, close it
	// 		if ($(".task-manager-container").is(':visible')) {
	// 			$(".task-manager-container").slideToggle("fast");
	// 			$(".task-manager-link a").css('background-color', 'transparent');
	// 		}

	// 		// if quick actions is open, close it
	// 		if ($(".quick-actions-container").is(':visible')) {
	// 			$(".quick-actions-container").slideToggle("fast");
	// 			$(".quick-actions-link a").css('background-color', 'transparent');
	// 		}

	// 		// display account messages
	// 		$(".account-messages-container").slideToggle("fast", function accountMessagesSlideToggle() {
	// 			if ($(".account-messages-container").is(':visible')) {
	// 				$(".account-messages-link a").css('background-color', 'rgba(0,0,0,0.2)');

	// 				loadAccountMessages();
	// 		} else {
	// 				$(".account-messages-link a").css('background-color', 'transparent');
	// 			}
	// 		});
	// 	});
	// }

	// function handleInstantNotificationClick() {
	// 	// handle instant notification close icon click
	// 	$(".alert-close").click(function hideInstantNotification(e) {
	// 		var $self = $(this),
	// 		    account_message_id = $self.data('account-message-id');

	// 		e.preventDefault();

	// 		Adzuki.Ajax.get('/AccountMessages/removeInstantNotification/' + account_message_id)
	// 		.then(function success(data) {
	// 			$('.account-message-' + account_message_id).addClass('hidden');
	// 		});
	// 	});
	// }

	// function loadAccountMessages() {
	// 	Adzuki.Ajax.get('/AccountMessages/listMessages/')
	// 	.then(function success(data) {
	// 		$(".account-messages-content").html(data);

	// 		$('.account-messages-link > a').removeClass('nav-badge');
	// 	});
	// }
}(jQuery, window.Adzuki || {}));